import { FETCH_OPPORTUNITY_STATUSES_SUCCEEDED } from './opportunityStatus.action';
import { pathOr } from 'ramda';

export const opportunityStatusReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_OPPORTUNITY_STATUSES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/opportunityStatuses/opportunityStatus.reducer.js